var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.04H5C3.34315 22.04 2 20.6969 2 19.04V3.04004C2 2.48776 2.44772 2.04004 3 2.04004H17C17.5523 2.04004 18 2.48776 18 3.04004V15.04H22V19.04C22 20.6969 20.6569 22.04 19 22.04ZM18 17.04V19.04C18 19.5923 18.4477 20.04 19 20.04C19.5523 20.04 20 19.5923 20 19.04V17.04H18ZM16 20.04V4.04004H4V19.04C4 19.5923 4.44772 20.04 5 20.04H16ZM6 7.04004H14V9.04004H6V7.04004ZM6 11.04H14V13.04H6V11.04ZM6 15.04H11V17.04H6V15.04Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.52e7a2bbf4dfb89e0a1256a9310de48f.svg";
export { ForwardRef as ReactComponent };